import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createBlock(_component_q_btn, {
    label: _ctx.label,
    round: "",
    title: "Manage clients",
    onClick: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (!_ctx.hasSubscriptions)
        ? (_openBlock(), _createBlock(_component_q_icon, {
            key: 0,
            name: "fa fa-plus"
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["label", "onClick"]))
}